<template>
    <component :is="template">
        <v-card elevation="0" tile max-width="100%">
            <v-card-title class="tit tit--lg">
                <span class="py-4 pl-4"><b>모바일 도서교환권</b></span>
            </v-card-title>
            <v-divider/>
            <v-card-text>
                <p class="mb-0 pl-4"><v-icon size="20" class="mr-2" color="orange darken-2">mdi-help-circle-outline</v-icon><b>모바일 도서교환권 이용방법</b>!</p>
                <v-img src="/images/sub/exchange-guide.jpg" width="100%" contain />
            </v-card-text>
            <v-divider/>
            <v-card-text>
                <v-radio-group v-model="selected">
                    <v-row>
                        <v-col v-for="product in products" :key="product._id" cols="6" md="3">
                            <v-card elevation="0">
                                <v-card-text class="black--text">
                                    <v-img :src="product.thumb" max-width="500" height="172" contain class="mx-auto"></v-img>
                                    <v-responsive class="mt-4 text-center">
                                        <div class="tit tit--xs text-truncate" >{{ product.name }}</div>
                                        <v-layout class="mt-1 caption text-truncate" justify-center>
                                            <span>{{ product.writer }}</span>
                                            <v-divider v-if="product.writer && product.publisher" vertical class="mx-2 my-1"/>
                                            <span>{{ product.publisher }}</span>
                                        </v-layout>
                                        <div class="font-size-16 mt-1"><b class="primary--text">{{ product.salePrice.format() }}</b> 원</div>
                                        <div class="text-center my-2"><v-radio class="d-inline-block" :value="product._id" /></div>
                                    </v-responsive>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-radio-group>
            </v-card-text>
            <v-card-actions class="pa-4">
                <v-btn width="140" color="accent" x-large class="mx-auto" @click="order">선물교환</v-btn>
            </v-card-actions>
        </v-card>

        <login-dialog ref="loginDialog" />
    </component>
</template>
<script>
import api from "@/api";
import { mdiHelpCircleOutline } from "@mdi/js";
import LoginDialog from "@/components/client/login/login-dialog.vue";
export default {
    components: {
        LoginDialog
    },
    data(){
        return {
            mdiHelpCircleOutline,

            filter: {
                searchKey: "codes",
                searchValue: [
                    "ex20220331", "22101300002", "22101300001", "2004080001","2010070052" ,
                    "1712200044","2008180001","2105240002","2008180003","1712220001", 
                    "2103150001", "22100600002", "2204080028", "23052300001", "23031000002", 
                    "23110700001", "23101300004", "23031000001", "23040400001", "23031000003", 
                    "23101300003", "24011900005", "24011900001", "23101300002", "24011900002",
                    "24070500002", "24070500001", "24071900001", "24071900002", "24071900003",
                    "24071900004", "24071900005"
                ]
            },

            summary: { totalCount: 0 },
            products: [],

            selected: null
        }
    },
    mounted(){
        if(!this.logon){
            alert("로그인 이후에 사용가능합니다");
            this.$router.push(`/login`);
            return;
        }
        this.init();
    },
    methods: {
        async init(){
            this.search(false);
        },
        async search(routable = false){
            let { summary, products } = await api.v1.shop.products.gets({
                params: this.filter
            });

            products = products.sort((a, b) => this.filter.searchValue.indexOf(a.code) < this.filter.searchValue.indexOf(b.code) ? -1 : 1 )

            this.products = products;
            this.summary = summary;
            this.pageCount = Math.ceil(summary.totalCount / this.limit);
        },

        validate(){
            try{
                if(!this.selected) throw new Error("교환 상품을 선택해주세요");
                return true;
            }
            catch(error){
                alert(error.message);
            }
            return false;
        },

        async login(){
            return new Promise((resolve, reject) => {
                if(this.logon) resolve();
                else{
                    this.$refs.loginDialog.$off();
                    this.$refs.loginDialog.$on("login", _ => resolve());
                    this.$refs.loginDialog.$on("cancel", _ => reject());
                    this.$refs.loginDialog.open();
                }
            });
        },

        order(){
            if(this.validate()){
                this.login().then(async _ => {
                    await this.$store.dispatch("pickup", { carts: [{ product: this.products.find(product => product._id == this.selected), quantity: 1 }] });
                    this.$router.push(`/shop/exchange-order`)
                });
            }
        }
    },
    computed: {
        template(){ return () => import(`@/templates/${this.$theme.pages.shop}`); },
        logon(){ return !!this.$store.state.accessToken; }
    },
}
</script>

<style scoped>
.v-btn-toggle>>>.v-btn {
    opacity: 1 !important;
}
</style>